import { COPYING_ENTITY_FAILED, COPYING_ENTITY_REQUEST, COPYING_ENTITY_SUCCEEDED, MOVING_ENTITY_FAILED, MOVING_ENTITY_REQUEST, MOVING_ENTITY_SUCCEEDED } from "../actions/actionTypes";

interface Entities {
  copy: {
    copying: boolean;
    copied: boolean;
    error: any;
  },
  move: {
    moving: boolean;
    moved: boolean;
    error: any;
  },
};

const initialState: Entities = {
  copy: {
    copying: false,
    copied: false,
    error: null
  },
  move: {
    moving: false,
    moved: false,
    error: null
  },
};

interface EntitiesActions {
  [key: string]: any;
}

export function entitiesReducer(state: Entities = initialState, action: EntitiesActions): Entities {
  switch (action.type) {

    case COPYING_ENTITY_REQUEST: {

      return {
        ...state,
        copy: {
          copying: true,
          copied: false,
          error: null
        }
      }
    }

    case COPYING_ENTITY_SUCCEEDED: {

      return {
        ...state,
        copy: {
          copying: false,
          copied: true,
          error: null
        }
      }
    }

    case COPYING_ENTITY_FAILED: {

      const data = action.payload;

      return {
        ...state,
        copy: {
          copying: false,
          copied: false,
          error: data
        }
      }
    }

    case MOVING_ENTITY_REQUEST: {

      return {
        ...state,
        move: {
          moving: true,
          moved: false,
          error: null
        }
      }
    }

    case MOVING_ENTITY_SUCCEEDED: {

      return {
        ...state,
        move: {
          moving: false,
          moved: true,
          error: null
        }
      }
    }

    case MOVING_ENTITY_FAILED: {

      const data = action.payload;

      return {
        ...state,
        move: {
          moving: false,
          moved: false,
          error: data
        }
      }
    }


    default:
      return state;
  }
}